import React, { Component } from 'react';
export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <section class='pt-4 pb-[22px]'>
        <div class='container'>
          <div class='grid grid-cols-1'>
            <div class='text-center'>
              {/* <div class='w-[50px] h-[50px] bg-custom/20 rounded-full leading-[50px] flex items-center justify-center mx-auto'>
                <img
                  src='assets/images/icon/heart.svg'
                  alt='heart'
                  class='h-[30px] mx-auto'
                />
              </div> */}
              <p class='mt-6 text-muted'>&copy; 2023 DyuniAir.co.th</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
